import * as mutationTypes from './mutation-types'

import { filterItems, prepareData } from './helpers'

const Workflows = {
  state() {
    return {
      data: [],
    }
  },

  getters: {
    processedWorkflows: ({ data }, _getters, { query }) => {
      return filterItems(data, query.currentQuery)
    },
  },

  mutations: {
    [mutationTypes.SET_WORKFLOWS_DATA](state, data) {
      state.data = prepareData(data, 'Workflow')
    },
  },
}

export default Workflows
